import {
  useUserContext
} from "./chunk-MPXR4OUE.js";
import {
  axios_default
} from "./chunk-3TVYLYMS.js";
import {
  notify
} from "./chunk-DL5QNKBI.js";
import {
  Image
} from "./chunk-2MXWHUGP.js";

// src/pages/Licenses/Payments.tsx
import React, { useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import io from "socket.io-client";

// src/assets/images/payment/aesirx.png
var aesirx_default = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFISURBVHgBzZa/S8NAFMe/LyqIhVKHOsVSN39MDh3c0snFsaY46eLiYt3cYkZBEQd3OzbSv8Eu6upiZyGZmiUUM4l5JoWCg9DcJTn6gePg4Phw7957d4SYmvlkMXMH4ApyhwIQP7pO+4JqZu+OGR0UDHFka2A6gQKY6FzjQkL3H1TRoJD5lvUsA7dnDcgwfyfTqyvIg5myvZ0qXh8OcGjUkZWZsrcPPx4jWMe72K5nq5JUYTy9eYHrh3CsJtbXSpAllWwcfqNtP0+EerVg2V+hFwv3G7pU0gilfiJ0RyHKpSU4V01hoVSdJUkDhrBQSub5XzDtgbBQuoMkdzcVtoyNVHsWkYGpMJnTkLk3phXlIhNBOIx2931SAkpkw88Asqh9zyj51ymBAy3in3sogCN0F8bD/qC81Vol0jbjtWXkDgXM0bXXP7r8BX+nd21VPevcAAAAAElFTkSuQmCC";

// src/assets/images/payment/usdt.png
var usdt_default = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGpSURBVHgB7Za/T8JAFMdfD1BMgAQWJcakxIW6y8BonFzUP4Bg/wQnoxOTiYkJDq6E8AcY42Kig6MJxMUJNzpIwMU2FiIItt5rLbEKlDa2MYbP0r7ej++99+5ej4FPksUcq5L+pqq8R+GXYYhP7Cr+C4HPCQx+WC7ub/kIOQd3EVRF3Sb4RsXy4D4sECZPksU9VjM8gIaTJeAx/1/Qb9XhYHUDuGgcJqX8VIPT+xtwLIhiqYUETMpjWxzb/vdCenh3CeFAcGBzsbgWZoPMVcHUv27hoaVg9bkxtr1Cc2aHiXIYng2C3O3odsy8gVLzCZDf9LaX3itEAnNQFRv2BdeXOEjSyUvVW5DFzuB7eCZo6vfDwxBAlktDpVkbKjxScDGk/zTQQxxoeCH3OlBuDg8jLgb742JHpYLBWqoQ/8hEYMjwWEQMz1RzWPHcGW31lqQJjcmrYJlDHPx1AlxAdiU9sDPXBbDDtHhPBW1juUu/gzt27ewYnGJbEKm3JXCK9zl84I8E+nS+ZBvQIiVoHtIL6i64j9RT+jxjWFpNBbIDLqBf9VslgT+RPgC1wI8COHPcIQAAAABJRU5ErkJggg==";

// src/assets/images/payment/bnb.png
var bnb_default = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKISURBVHgBzVa/a1NRFP7uuy8/bQQdRDOoKJhBaSNEUFBIQSh0ELcO/Qe6aYeuHbo6xDFDF4cO3cRB0Q4RFHRwSEWHDPXXEFCHQGPS/HzP893mFYz48hKb0A9ecnPf433nO+d850ahh8pWOms5ThZjgNb4PHX7/SOuFT92t6ZzylX3MV4UOzU1qyvP0lmtkMf4cRq2+93SunseE4K21IyFCePoE6poErHMOuI3n8JO3sGwCEyo7ATCF5cQv7EJfSIDFUogenkN8eubJohDJwydXUT4whKcagn1twuoFW6hWXpgiGPX1gOT2n43rUQKkdQKnL0yWjt5dH4W4Mo6dG4R9kwOje1l1GUP7Sr0yQxCV9bMM+2vG/9+px9hWFQxfSRBp2rS6sq3KwRUyrVFZbLPoKxYEpFLK75qB6bUqPuURzSdO2gWkjU/rpqAuMeLZM2dwfPDN6UNeal9Zr8TqdREGNvvUren2NuzplLoVt6h9noebqOMkRSyK51fJbNul5/8cc8jIxwhYO2onKpHTinrE5XmINg0/dFTJff33iyYurKTefm+EwHBNGrp2saH1YM9Kmp/2zD1DQUcAsGNLwcZ6/QXxIe0j5f6QbAHPcCGYC1rr+ah2Bz99ZFU1uUeSYOo9FXYFDt0fhTMhKEdSGbSKMZmo7R6NojIiGPKqZbTx69LfRXS8JwmHNIRUelZoyV1gwTD6UIS+9SsqSUDYCP5YWBKiY5YghdTStJjPR9Sbbe4bGYr10Ew1PFExTQ3PUlCqvKIgyKQwn5SjjVvrg6LkU/8Ucj+i3BUWKqrv2BScNVL80e4+mL6ocySexgnXBQTc9tXlfd793n6rgsnjTFAwSoenys+5vo3eTAZ6ixLYQIAAAAASUVORK5CYII=";

// src/assets/images/payment/concordium.png
var concordium_default = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHdSURBVHgBvVaLkYIwEF2cK8ASKIES6EA6kA6kA7UCsAM68DqQDqQD7UA7yOUxl3Oz+SB3cG8mA5PPvs3L7iYJfUMpVehPRsugT5LkkxjZVS2P2pCVYzMvl4s6HA4qz3O1Xq8VlqGlaTr0Xa9v+5uDsA2NwhAMGoJQa9v2XcLyIyT66XSiqqpobngJj8cjaQmdfi0naRmH9nw+h9b3PU2ClBRnRUIynFXTNOrxeDga3W43b39IUosQiyXZdrudYnAaoQyQ3W7nXTXmAMbhvGf3L0KEvpRRAnLztMiyzIlQqRLmM9IXIaSjSKjDOAXSAo5w6Oi2xrEZh5AbhFdyZzSSi8yooxYccAj5hKIoLEIuY6jh/ENrmL1yhdS43+9WqiDPDDCGfBuDtIGcNeC5uqKZEHOKkw+EfEcA9xaT+YIQdAxEbViEkrTrOmvyOzVV5+zPvyx3ljMmaCKhrHxpw9t+v4/OPZ/PbpT6El9WFBhGP7HIlI7JxBcFJF7aynL0bp4KmxAXrpQLpIsVb6Cua+/1hFLnIzaF+teEAM6KIhXFNHOeU54YwTdNjJT+8KYJVho8MbRUtNlsaFZo1mrMLZxR6JmIwjz1mYi76D8ewg02mLCdlvqT0jLo9FO/w88Xbz5/JNYM8PsAAAAASUVORK5CYII=";

// src/assets/images/payment/visa.png
var visa_default = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAOCAYAAABU4P48AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAM3SURBVHgBfVW9TxRBFH9vAIEYk7WTiqW24EisbDzUzoLTxINgwS1aWJgg8Q8AQ2KNsVX2KDSIBUdnuRTWHsZCC8Na+NG5NAoSd3yzMztfe8dLdufrzW9+72Pe4PGrsQYizkDOQ7CFYTp09HsZoyxz5pvxCiDU9fgYbsIZPgOILT33OprW/UYcwBlYUntq9AX0CcwuzT2GrSjx8Bs0v6D0AHi+C9t318vlweH5Hx1qO39eXmgxxBUEDKUicRke3SdsrQxzcUjzqxZ8GzpRBrN0CGgjunp1Pq7BP9ihXgiuBIV+TmQAEg9/x9FEJnQ1B1Z2Ru/8bA9vP5la+3xN65IBk95BdRcMNpVxoZnkX3W3SjZVn4waY104DV9KrYiST7gQ8tbap6vJpeQBZCcjgkjNWedFqMzhZTjR0uNckmg+bzhkOSxTqkyo7zztmYYj6Hr4K9BLRgw+q67y/Q+HY3D93b3COh4H0joRLtsDnK8W7e3YNQrxverUPNxfzlAYK9KpFNfAlMgbY/L8FMKIIqdBkH708QacnB0KFcGHllYGf3G36A1A4O0/lMgs8ebblOuxMrwqOLBkCPJdQL5n1thkf8IyTIXlz75chrffLtbVrhlLq6O9Y1lv7QeVLomH3iLPHRSVxhY/egO4Tgba6VLvT1gS0cr3u7cmCVBsCLVODk91H9kVa3fqhFmUN1G6fEGqNM0XVsRUeklJyNiULqxNOCwvXo8cBln7lHw/Okce5C0H8E1kgwUOYV+2olUiOEEh3nRJM+NljsZozttFK88wxquLNwi9RJQbrkc1AgwrgGCtl5LzfeglwmMiHWbjcTDhLS9zyymLMtfbFQyZegnrc0ACtnXGiylsLxpPyTAZDyNPi7a5sVB8tkjd0JqRuv1KmS+IddEMnqKSiGN6zBkRYeLWuHwIEBvFXumpVK2GLgF6dMTd4E6tFs91Zo0DU+PlI9afMM/3KM8a3iHuBRJhQitIZYUQJFDPhhVsQVbk9txGG4wiRS+acvTkU32gcShK/Qkz1iFlq5RRfm4tpp6S+CVqkOkKwaiKyFcxBPsxELqSbFKkCIdxvR9hr8JB5P5snOjxEIT/AXFNKcVqHm3NAAAAAElFTkSuQmCC";

// src/assets/images/payment/debit.png
var debit_default = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAOCAYAAADE84fzAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAG8SURBVHgBnVRLThtBEH3VE4PGY4Qd5WOCIo1XWUUhygXwPpJRLpAghUV2yRE4ScwJMOICwwEQLGEDg4T4iIUBY3kM011UG9nGgumReFKru7pfvaoudTXhEdoolw1KPw14iYAFBsqyHcs68qBXKziLe/+rIbP3l8ANgELrJ+e7INPkhDf8P2fxUI/GwvMLKbAuyxAZCL53W/gRLNJD0OcQG2P+Bb9PWyPxNqqhhrfD2U4ofu7IuEb6sYT00yxcSDXVZ1aOo4H4BeYPXRmrIMXrxvnIvv32BqYynSkuopfT1K2pC1QXXcLDrB/j1UHHRYetQM/4vxTDW0IOCu/7E7Zq90F3xulDpBpKrvDFSZoy8AL99CDRyEEo4nSJF4BSk8tR8qaPXAS+VTLo6X6pgBzENvNWHis5LE7YpjIFLiinjwc01VscR7KOXMTe3syErecCuMGx7uutQfgUelmmzNqbroeb7YfG0dJE+kPRra3Vsv0GBuJz8mdIgK8sEbP4yX4JSWc2unN0J9sEpTv9lUE1MCqcDfAOJzUh2FtE45twLHtNeR91f/OqDtI1eSdrbD+rsegumFZ96cqhsMU9m9+fUI+h6F4AAAAASUVORK5CYII=";

// src/pages/Licenses/Payments.tsx
var socket;
var listPaymentSellix = [usdt_default, bnb_default, concordium_default, visa_default, debit_default];
var Payments = ({ item, license, show, setShow, backToLicense, subscription, addNew }) => {
  const { aesirxData, preregistration } = useUserContext();
  const product = license?.subscription?.[0]?.product;
  const aesirxpackage = item?.title.toLowerCase();
  const [saving, setSaving] = useState(false);
  const handleAesirX = async () => {
    setSaving(true);
    try {
      const res = await axios_default.post(`/api/license`, {
        payment_method: "aesirx",
        product,
        aesirxpackage,
        buyer_id: aesirxData.id,
        subscription_id: addNew ? "" : subscription?.id
      });
      if (res?.data?.result) {
        notify(addNew ? "Create successfully!" : "Upgrade successfully!", "success");
        backToLicense(true);
      } else {
        notify("Not enough", "error");
        setShow(false);
      }
    } catch (error) {
      setSaving(false);
      notify(error?.response?.data?._messages?.[0]?.message || error?.message, "error");
    }
  };
  useEffect(() => {
    (async () => {
      const createSocketServer = async () => {
        await axios_default.get(`${process.env.NEXT_PUBLIC_PARTNERS_URL}/api/socket`);
      };
      createSocketServer();
      if (!socket && process.env.NEXT_PUBLIC_PARTNERS_URL) {
        socket = io(process.env.NEXT_PUBLIC_PARTNERS_URL, {
          reconnection: true,
          secure: true,
          rejectUnauthorized: false,
          transports: ["polling"]
        });
      }
      socket.on("connect", () => {
        socket.on("web3id-update", (msg) => {
          const web3id = preregistration.id;
          if (msg === web3id) {
            notify(addNew ? "Create successfully!" : "Upgrade successfully!", "success");
            backToLicense(true);
          }
        });
      });
      if (aesirxpackage === "community") {
        await handleAesirX();
        setShow(false);
      }
    })();
  }, []);
  return /* @__PURE__ */ React.createElement(Modal, { show, onHide: () => setShow(false), centered: true }, /* @__PURE__ */ React.createElement(Modal.Header, { closeButton: true, className: "border-0" }), /* @__PURE__ */ React.createElement(Modal.Body, { className: "px-40px pb-5 pt-0" }, /* @__PURE__ */ React.createElement("div", { className: "border-top pt-4" }, saving ? /* @__PURE__ */ React.createElement("div", { className: "d-flex justify-content-center" }, /* @__PURE__ */ React.createElement(Spinner, null)) : /* @__PURE__ */ React.createElement(React.Fragment, null, " ", /* @__PURE__ */ React.createElement("p", { className: "fs-6 fw-normal mb-4 text-dark" }, "How would you like to pay?"), /* @__PURE__ */ React.createElement("h3", { className: "fs-18 fw-medium text-dark mb-3" }, "Token $AESIRX"), /* @__PURE__ */ React.createElement(
    Button,
    {
      className: "border mb-4 rounded w-50 px-3 py-13px fs-18 d-flex align-items-center",
      variant: "light",
      onClick: handleAesirX
    },
    /* @__PURE__ */ React.createElement(
      Image,
      {
        className: "me-10px",
        src: aesirx_default,
        quality: 100,
        alt: "Aesirx Payment Icon"
      }
    ),
    "AesirX"
  ), /* @__PURE__ */ React.createElement("h3", { className: "fs-18 fw-medium text-dark mb-3" }, "Sellix Payment", /* @__PURE__ */ React.createElement("span", { className: "fs-6 fst-italic fw-normal" }, "(Support Crypto currencies, Credit/Debit Cards)")), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    "div",
    {
      "data-sellix-product": item?.plan_id,
      "data-sellix-custom-product": product,
      "data-sellix-custom-package": aesirxpackage,
      "data-sellix-custom-buyer_id": aesirxData.id,
      "data-sellix-custom-subscription_id": addNew ? "" : subscription?.id,
      "data-sellix-custom-addnew": addNew,
      "data-sellix-custom-requested_username": preregistration?.id,
      className: "d-flex flex-wrap cursor-pointer"
    },
    listPaymentSellix && listPaymentSellix.map((gateway, index) => {
      return /* @__PURE__ */ React.createElement(
        Button,
        {
          key: index,
          className: `border rounded col px-3 py-10px ${index ? "ms-18px" : ""} fs-18 d-flex align-items-center justify-content-center`,
          variant: "light"
        },
        /* @__PURE__ */ React.createElement(
          Image,
          {
            className: "rounded-1 object-fit-contain",
            src: gateway,
            quality: 100,
            width: 27,
            height: 27,
            alt: "Aesirx Payment Icon"
          }
        )
      );
    })
  ))))));
};
var Payments_default = Payments;

export {
  Payments_default
};
